'use client';
import { Icon } from '@/app/common';
import { cn } from '@workspace/lib';
import { theme } from '../../../theme';

interface PlayButtonProps {
  onPlay: () => void;
  variant?: 'default' | 'white';
  className?: string;
  ariaLabel?: string;
}

export function PlayButton({ onPlay, variant = 'default', className = '', ariaLabel = 'Play video' }: PlayButtonProps) {
  const iconName = variant === 'white' ? 'PlayCircleWhite' : 'PlayCircle';
  const iconClassName =
    variant === 'white'
      ? 'w-10 h-10 text-white cursor-pointer'
      : cn(
          'w-12 h-12 text-primary cursor-pointer md:w-10 md:h-10',
          // The PlayCircle SVG hard-codes a red fill, so override it directly on the
          // paths to render the brand green play button for the redRec theme.
          theme === 'redRec' && '[&_path]:fill-[#004639]',
        );

  return (
    <button
      type="button"
      className={`p-2xs cursor-pointer relative z-20 ${className}`}
      aria-label={ariaLabel}
      onClick={(e) => {
        e.stopPropagation();
        onPlay();
      }}
    >
      <Icon name={iconName} className={iconClassName} />
    </button>
  );
}
